define('persistence/dataProviders/phoneConnectorDataProvider',['externalDependencies/kazooApi',
    'common/promises/promiseFactory'
], function() {

    return function() {
        var self = this;

        var KazooConstructor = require('externalDependencies/kazooApi');
        var _kazooApi = new KazooConstructor();

        var PromiseFactoryConstructor = require('common/promises/promiseFactory');
        var _promiseFactory = new PromiseFactoryConstructor();

        self.getAll = function() {
            return _promiseFactory.defer(function(deferredObject) {
                _kazooApi.callAccount('/lobby_phone_connectors', 'GET')
                    .done(function(result) {
                        deferredObject.resolve(result.data.data);
                    })
                    .fail(function(error) {
                        deferredObject.reject(error);
                    });
            });
        };

        self.getById = function(phoneConnectorId) {
            if (phoneConnectorId === null) {
                var err = new Error("Missing phoneConnectorId");
                throw err;
            } else {
                return _promiseFactory.defer(function(deferredObject) {
                    _kazooApi.callAccount('/lobby_phone_connectors/' + phoneConnectorId, 'GET')
                        .done(function(result) {
                            deferredObject.resolve(result.data.data);
                        })
                        .fail(function(error) {
                            error.phoneConnectorId = phoneConnectorId;
                            deferredObject.reject(error);
                        });
                });
            }
        };
    };
});
